import { render, staticRenderFns } from "./SignPage.vue?vue&type=template&id=0869b2bd&"
import script from "./SignPage.vue?vue&type=script&lang=js&"
export * from "./SignPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports